<template>
  <div id="members-top-picks" class="destination-members-top-picks push-v--desktop--small push-v--tablet--small push-v--mobile--small">
    <section class="destination-members-top-picks--wrapper">
      <div class="destination-members-top-picks--main-content">
        <h1 class="destination-members-top-picks--title">{{ title }}</h1>
        <div class="destination-members-top-picks--description">{{ description }}</div>
      </div>
      <div class="destination-members-top-picks--carousel-wrapper">
        <div class="destination-members-top-picks--carousel">
          <div v-for="(member, index) in membersPicks" :key="index" class="destination-members-top-picks--carousel-item">
            <div class="destination-members-top-picks--carousel-image">
              <img :src="member.image && member.image.url">
              <div class="destination-members-top-picks--carousel-name">{{ member.name }}</div>
            </div>
            <div class="destination-members-top-picks--carousel-title">{{ member.title }}</div>
            <div class="destination-members-top-picks--carousel-description">{{ member.description }}</div>
            <div class="destination-members-top-picks--carousel-link"> 
              <a :href="member.ctaLink" target="blank">{{ member.ctaText }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="destination-members-top-picks--carousel-scrollbar-wrapper">
        <div @click="scrollToLeftEnd">
          <arrow-icon class="destination-members-top-picks--carousel-arrow destination-members-top-picks--carousel-arrow-left hidden" />
        </div>
        <div class="destination-members-top-picks--carousel-scrollbar">
          <div class="destination-members-top-picks--carousel-dragger" />
        </div>
        <div @click="scrollToRightEnd">
          <arrow-icon class="destination-members-top-picks--carousel-arrow destination-members-top-picks--carousel-arrow-right withBounce" />
        </div>
      </div>
    </section>

    <div class="destination-members-top-picks--bottom-edge" />
  </div>
</template>
<script>

import ArrowIcon from '~/assets/icons/arrow-right-simple.svg?inline';

export default {
  components: {
    ArrowIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    description: {
      type: String,
      default: '',
      required: true,
    },
    membersPicks: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      pos: { top: 0, left: 0, x: 0, y: 0 },
      carousel: '',
      scrollPosition: 0,
      scrollbar: '',
      dragger: '',
      scrollbarWidth: 0,
    };
  },
  mounted() {
    this.carousel = document.querySelector('.destination-members-top-picks--carousel-wrapper');
    
    if (this.carousel) {
      this.carousel.addEventListener('mousedown', this.mouseDownHandler);
      this.carousel.addEventListener('scroll', this.isScrolling);

    }
    this.dragger = document.querySelector('.destination-members-top-picks--carousel-dragger');
    const scrollbar = document.querySelector('.destination-members-top-picks--carousel-scrollbar');
    this.scrollbarWidth = scrollbar.clientWidth - this.dragger.clientWidth;
  },
  methods: {
    scrollToRightEnd() {
      const rightEdge = this.carousel.scrollWidth - this.carousel.clientWidth;
      this.carousel.scroll({
        left: rightEdge,
        top: 0,
        behavior: 'smooth',
      });

      this.scrolledToRight();
    },
    scrollToLeftEnd() {
      this.carousel.scroll({
        left: 0,
        top: 0,
        behavior: 'smooth',
      });
      this.scrolledToLeft();
    },


    scrolledToLeft() {
      document.querySelector(`.destination-members-top-picks--carousel-arrow-right`).classList.remove('hidden');
      document.querySelector(`.destination-members-top-picks--carousel-arrow-left`).classList.add('hidden');
    },
    scrolledToRight() {
      document.querySelector(`.destination-members-top-picks--carousel-arrow-right`).classList.add('hidden');
      document.querySelector(`.destination-members-top-picks--carousel-arrow-left`).classList.remove('hidden');
      document.querySelector(`.destination-members-top-picks--carousel-arrow-right`).classList.remove('withBounce');
    },

    isScrolling(evt) {
      const scrollableDistance = this.carousel.scrollWidth-this.carousel.clientWidth;
      const currentPosition = this.carousel.scrollLeft;
      this.scrollPosition = currentPosition/scrollableDistance;
      const draggerPosition = this.scrollPosition*this.scrollbarWidth;
      this.dragger.style.left = `${draggerPosition}px`;


      if (this.carousel.scrollLeft<=0) {
        this.scrolledToLeft();
      }
      if (this.carousel.scrollLeft>=this.carousel.scrollWidth - this.carousel.clientWidth) {
        this.scrolledToRight();
      }
    },
    mouseDownHandler(e) {
      // Change the cursor and prevent user from selecting the text
      this.carousel.style.cursor = 'grabbing';
      this.carousel.style.userSelect = 'none';

      this.pos = {
        left: this.carousel.scrollLeft,
        top: this.carousel.scrollTop,
        x: e.clientX,
        y: e.clientY,
      };

      document.addEventListener('mousemove', this.mouseMoveHandler);
      document.addEventListener('mouseup', this.mouseUpHandler);
    },
    mouseUpHandler() {
      this.carousel.style.cursor = 'grab';
      this.carousel.style.removeProperty('user-select');
      document.removeEventListener('mousemove', this.mouseMoveHandler);
    },
    mouseMoveHandler(e) {
      // How far the mouse has been moved
      const dx = e.clientX - this.pos.x;
      const dy = e.clientY - this.pos.y;

      // Scroll the element
      this.carousel.scrollTop = this.pos.top - dy;
      this.carousel.scrollLeft = this.pos.left - dx;
    },

  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_destination-members-top-picks.scss';
</style>
